/*
 *
 * Authorization API Constants
 *
 */

import { SERVICE_NAMESPACE } from 'common';
import { getAppConfigSetting } from '../../utils';

export const NAMESPACE = `${SERVICE_NAMESPACE}/getLoginType`;

export const URL = `${getAppConfigSetting('legitUrl')}/legit/api/v2/session/logintype`;

export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;

export const MAKE_REQUEST = `${NAMESPACE}/MAKE_REQUEST`;

export const LOADING = `${NAMESPACE}/LOADING`;

export const FAILURE = `${NAMESPACE}/FAILURE`;

export const SUCCESS = `${NAMESPACE}/SUCCESS`;

export const CLEAR = `${NAMESPACE}/CLEAR`;



// WEBPACK FOOTER //
// ./src/services/LoginType/constants.js